import { render, staticRenderFns } from "./searchclr.vue?vue&type=template&id=3bd9dc50&scoped=true&"
import script from "./searchclr.vue?vue&type=script&lang=js&"
export * from "./searchclr.vue?vue&type=script&lang=js&"
import style0 from "./searchclr.vue?vue&type=style&index=0&id=3bd9dc50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd9dc50",
  null
  
)

export default component.exports